/**
 * currencyIcons.ts — the TWO currency glyphs (M131, owner rule).
 *
 * The game has two points pools and they are always drawn differently:
 *
 *   XP  (Experience Points) — GOLD STAR. Earned by racing, never spent, never
 *       bought. Unlocks rides, sets the rank tier, ranks the leaderboard.
 *       Shown as PROGRESS (a bar toward the next ride / rank), never as a
 *       bare balance.
 *   SP  (Shop Points) — GREEN COIN. Earned 1:1 with XP, plus bought packs,
 *       minus shop spending. Only the shop reads it. Shown as a BALANCE.
 *
 * Every surface that names a currency uses these glyphs + the matching
 * colour (gold = XP, green = SP) so the two can never be confused again.
 */

export const XP_STAR_SVG =
  '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2.5l2.6 6.03 6.54.56-4.96 4.3 1.49 6.4L12 16.4l-5.67 3.4 1.49-6.41-4.96-4.3 6.54-.56L12 2.5z"/></svg>';

/** A coin: outer ring, inner disc, a small notch so it reads as minted. */
export const SP_COIN_SVG =
  '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
  '<circle cx="12" cy="12" r="9.2" stroke="currentColor" stroke-width="2.2"/>' +
  '<circle cx="12" cy="12" r="4.6" fill="currentColor"/>' +
  '<path d="M12 5.6v2.2M12 16.2v2.2M5.6 12h2.2M16.2 12h2.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
  '</svg>';

/** Short display names — the interface only ever says XP and SP. */
export const XP_LABEL = 'XP';
export const SP_LABEL = 'SP';

/** Long names, for the guide and legal copy only. */
export const XP_LONG = 'EXPERIENCE POINTS';
export const SP_LONG = 'SHOP POINTS';
